export enum PositionType {
    VESSEL = 'VESSEL',
    NEXT_PORT = 'NEXT_PORT',
    LAST_PORT = 'LAST_PORT',
    ORDER_PORT = 'ORDER_PORT',
}
